/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './home.scss';

import HomeRoutes from './home.routes';
import HomeController from './home.controller';
import BreadcrumbLabel from './breadcrumb-label.filter';
import {BreadcrumbIcon, BreadcrumbSvgIcon} from './breadcrumb-icon.filter';

export default angular.module('tektelic.home', [])
    .config(HomeRoutes)
    .controller('HomeController', HomeController)
    .filter('breadcrumbLabel', BreadcrumbLabel)
    .filter('breadcrumbIcon', BreadcrumbIcon)
    .filter('breadcrumbSvgIcon', BreadcrumbSvgIcon)
    .name;



// WEBPACK FOOTER //
// ./src/app/layout/index.js